import { useRef, useState } from "react";

/**
 * Tiny single-purpose hook for the chat input: holds the current text
 * and a ref the consumer can attach to the <input> element.
 *
 * Phase 4 of plans/useChatHook-enterprise-grade.md moves the call site
 * directly into Chat.jsx; in Phase 3 it's exposed via useChatHook for
 * contract compatibility.
 */
export function useChatInput() {
  const [inputContent, setInputContent] = useState("");
  const inputRef = useRef(null);
  return { inputContent, setInputContent, inputRef };
}
